import { config } from '../../../../core/config/config';
import fetch from 'isomorphic-fetch';
import store from '../../../../core/redux/store';
/**
 * Get client settings
 * @function
 *
 * @throws {Error}
 * @returns {Promise}
 */

export const getOrganisationSettings = async (): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const uri = `${config.uri.client_admin_api}/settings`;
    const options = {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
